// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";

var _map = {"Prod":"prod","Staging":"staging","Dev":"dev","LocalWithClientAPI":"local-clientapi","Local":"ENV_NOT_SET"};

var _revMap = {"prod":"Prod","staging":"Staging","dev":"Dev","local-clientapi":"LocalWithClientAPI","ENV_NOT_SET":"Local"};

function tierToJs(param) {
  return _map[param];
}

function tierFromJs(param) {
  return _revMap[param];
}

function WindowVariable(T) {
  var value = Belt_Option.flatMap(Js_dict.get(window, T.name), T.variantFromJs);
  return {
          value: value
        };
}

export {
  tierToJs ,
  tierFromJs ,
  WindowVariable ,
}
/* No side effect */
